<template>
  <p :id="props.id" class="modern-color-theme font-poppins" :class="theme.text" data-component-name="VSDescription">
    <slot />
  </p>
</template>
<script setup lang="ts">
import { useTheme } from '@component-library/themes/themes';
import type { ThemeProp } from '@component-library/themes/types';

const props = defineProps<{
  id?: string
  theme?: ThemeProp<'VSDescription'>
}>()

const theme = useTheme(props, 'VSDescription')

defineOptions({
  name: 'VSDescription'
})
</script>